import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupScreenshotWarningContentProps } from './msg-group-screenshot-warning-content';
import { MsgGroupScreenshotWarningContent } from './msg-group-screenshot-warning-content';

export interface MsgGroupScreenshotWarningProps extends MsgGroupScreenshotWarningContentProps {}

export const MsgGroupScreenshotWarning = memo(function MsgGroupScreenshotWarning({
  message,
}: MsgGroupScreenshotWarningProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupScreenshotWarningContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
